module.exports = __webpack_public_path__ + "static/the-most-powerful-idea-in-the-world-310bfafc62e1407a1e9572f6da01830d.jpg";